export const ActionTypes = {
    TOGGLE_VISIBLE: "app/redux/popup/TOGGLE_VISIBLE",
    TOGGLE_VISIBLE2: "app/redux/popup/TOGGLE_VISIBLE1",
}